import { GetContextResponse } from '@iwoca/lapi-client/edge';
import _ from 'lodash';

import { setCurrentStateKey } from './LendingAPI';

export function deserialiseSiteContext(site_context: GetContextResponse) {
    setCurrentStateKey(site_context.data!.state_key);
    const {
        state_key,
        country_code,
        user_signup_finished,
        user_date_joined,
        intercom_app_id,
        user_intercom_hash,
        user_intercom_jwt,
        // @ts-expect-error The API schema needs to be updated.
        is_iwocapay_seller
    } = site_context.data!;

    //TODO: deprecate and remove language_code instead of locale
    return {
        country_code,
        state_key,
        intercom_app_id,
        user_intercom_hash,
        user_intercom_jwt,
        user_date_joined,
        user_signup_finished,
        language_code: getLocale(site_context),
        currency: getCurrency(site_context),
        language: getLanguage(site_context),
        locale: getLocale(site_context),
        openBankingBanks: _.get(site_context, 'data.open_banking.banks', []),
        truelayerBanks: _.get(
            site_context,
            'data.open_banking.truelayer_banks',
            []
        ),
        loggedInUserType: _.get(site_context, 'data.logged_in_user_type'),
        isAccessUser:
            _.get(site_context, 'data.logged_in_user_type') === 'access_user',
        is_iwocapay_seller
    };
}

function getLanguage(site_context: GetContextResponse) {
    switch (_.get(site_context, 'data.country_code')) {
        case 'de':
            return 'de';
        case 'uk':
        default:
            return 'en';
    }
}

function getCurrency(site_context: GetContextResponse) {
    switch (_.get(site_context, 'data.country_code')) {
        case 'de':
            return 'EUR';
        case 'uk':
        default:
            return 'GBP';
    }
}

function getLocale(site_context: GetContextResponse) {
    switch (_.get(site_context, 'data.country_code')) {
        case 'de':
            return 'de-DE';
        case 'uk':
        default:
            return 'en-GB';
    }
}
